import { Component, OnInit, HostListener } from '@angular/core';
import { DashboardService } from '../dashboard.service';
import { Router, NavigationExtras } from '@angular/router';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ConfirmDialogModel, ConfirmationDialogComponent } from 'src/app/confirmation-dialog/confirmation-dialog.component';
import { MatDialog } from '@angular/material';
import { UserSubscriptionDilogComponent } from '../user-subscription-dilog/user-subscription-dilog.component';
import { DatePipe } from '@angular/common';
@Component({
  selector: 'app-normal-users',
  templateUrl: './normal-users.component.html',
  styleUrls: ['./normal-users.component.scss']
})
export class NormalUsersComponent implements OnInit {
  @HostListener('getAllNormalUserList')

  private ResponseVerifiedGetAllNormalUserList: Subject<any> = new Subject();
  private ResponseVerifiedGetDevicesNormalUser: Subject<any> = new Subject();
  private ResponseVerifiedChangePassword: Subject<any> = new Subject();

  pipe = new DatePipe('en-US');
  normalUserList = [];
  dataObject: any;
  role: any;
  epcId: any;
  page = 1;
  offset: any = 0;
  offsetNormalUserList: any = 0;
  roleName: string;
  srcString: any;
  search: any = '';
  limit: any = 10;
  ofsset: any = 0;
  deviceObject: any = {};
  normalUserDeviceList: any =[];
  selectedNormalUserId: any;
  closeResult: string;
  userChangePasswordRequestObject: any = {};
  normalUserListCount: any;
  constructor(private dashbord: DashboardService, private dialog: MatDialog,private router: Router, private modalService1: NgbModal,
    private toastr: ToastrService ) {
    this.role = localStorage.role;
    this.epcId = localStorage.id;
    if (this.role == '1') {
      this.roleName = 'admin';
    } else if (this.role == '2') {
      this.roleName = 'epc';
    }
  }

  ngOnInit() {

    if (this.roleName == 'epc') {
      this.getAllNormalUserList(this.search, this.limit, this.offsetNormalUserList);
    }


  }

  // get allEpc Normal user
  getAllNormalUserList(search, limit, offset) {
    if(offset == 0 ){
      this.page = 1;
    }

    this.dataObject = {
      search: search,
      limit: limit,
      offset: offset
    }

    this.dashbord.getNormalUserList(this.dataObject)
      .pipe(takeUntil(this.ResponseVerifiedGetAllNormalUserList))
      .subscribe(
        async data => {
          this.normalUserListCount =0;
          if (data.status) {
            this.normalUserListCount=data.count;

            this.normalUserList = data.resultObject;
          }
          else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info('Login Time-out .. Please login again');
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(data.message);
              this.normalUserList = data.resultObject;

            }

          }
        },
        err => {
          return console.error(err);
        }
      );
  }
  editNormalUser(userId) {
    let navigationExtras: NavigationExtras = {
      queryParams: {
        'id': userId,
      }

    };
    this.router.navigate(['/inject-solar/add-normal-user/'], navigationExtras)
  }

  // EDIT DEVICE
  EditDevice(userId,is_emeter) {
    let navigationExtras: NavigationExtras = {
      queryParams: {
        'id': userId,
        "isEditing": "true",
        'usertype': "normaluser",
        'is_emeter':is_emeter
      }

    };
    this.router.navigate(['/inject-solar/register-device'], navigationExtras)
  }
  viewDevice(viewDevices, userId) {
    this.normalUserDeviceList=[];
    this.getDeviceForNormalUser(userId);
    this.modalService1.open(viewDevices, { size: <any>'xl' });
  }

  //get devices by user id
  getDeviceForNormalUser(userId) {

    this.deviceObject = {
      epc_id: this.epcId,
      user_id: userId,
    }
    this.dashbord.getNormalUserDevicesById(this.deviceObject)
      .pipe(takeUntil(this.ResponseVerifiedGetDevicesNormalUser))
      .subscribe(
        async data => {
          this.normalUserDeviceList=[];
          if (data.status) {

            this.normalUserDeviceList = data.device_info;
          }

          else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(data.message);

            }

          }
        },
        err => {
          return console.error(err);
        }
      );

  }




  // change password modal start
  openResetPasswordDialog(content, id) {
    this.selectedNormalUserId = id;
    this.modalService1.open(content, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  onUpdate(formData) {
    this.userChangePasswordRequestObject = {
      user_id: this.selectedNormalUserId,
      new_password: formData.value.newPassword,
      confirm_password: formData.value.confirmPassword
    };
    this.changePasswordByUserId(this.userChangePasswordRequestObject);
  }

  // change password by userid Normal User
  changePasswordByUserId(userChangePasswordRequestObject) {

    this.dashbord.changePasswordByUserId(userChangePasswordRequestObject)
      .pipe(takeUntil(this.ResponseVerifiedChangePassword))
      .subscribe(
        async data => {
          if (data.status) {
            this.toastr.success('Password Changed Successfully!!');
            this.modalService1.dismissAll();
            this.getAllNormalUserList(this.search, this.limit,this.offsetNormalUserList);

          } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(data.message);

            }

          }
        },
        err => {
          return console.error(err);
        }
      );
  }

// pagination for normal user list
  nextPageNormalUserList(pageIndex): void {
      this.offsetNormalUserList = (pageIndex - 1) * 10;
      this.getAllNormalUserList(this.search, this.limit, this.offsetNormalUserList);

  }
  public confirmDialog(id: any): void {
    let message = "Are you sure you want to delete this User?";
    let title = "Confirm Action";
    const dialogData = new ConfirmDialogModel(title,message);
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '400px',
      data: dialogData
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result) {
        this.deleteNormlUserByUserId(id);
      }
    });
  }

  deleteNormlUserByUserId(id) {
var deletenormluserObj={
  user_id:id,
}
    this.dashbord.deleteNormalUserByEpc(deletenormluserObj)
      .pipe(takeUntil(this.ResponseVerifiedChangePassword))
      .subscribe(
        async data => {
          if (data.status) {
            this.toastr.success(data.message);
            this.getAllNormalUserList(this.search, this.limit,this.offsetNormalUserList);

          } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(data.message);

            }

          }
        },
        err => {
          return console.error(err);
        }
      );
  }
    // renew user subscription dilog box
    public confirmRenewDialog(id: any): void {
          const dialogRef = this.dialog.open(UserSubscriptionDilogComponent, {
        width: '400px',
        // data: dialogData
      });
      dialogRef.afterClosed().subscribe(result => {
      if(result!=undefined){
        if(result.start_date !=undefined && result.start_date !="" && result.start_date !=null && result.end_date !="" && result.end_date !=undefined &&result.end_date !=null ) {
           this.renewSubscriptionUser(id,result);
        }
      }
      });
    }

    // renew user by id
    renewSubscriptionUser(id,result) {
      var subscriptionNormalUserObj = {
        user_id: id,
        start_dt:this.pipe.transform(result.start_date, "yyyy-MM-dd"),
        end_year:result.end_date
      }
      this.dashbord.epcNormalUserSubscription(subscriptionNormalUserObj)
        .pipe(takeUntil(this.ResponseVerifiedChangePassword))
        .subscribe(
          async data => {
            if (data.status) {
              this.toastr.success(data.message);
              this.getAllNormalUserList(this.search, this.limit,this.offsetNormalUserList);

            } else if (!data.status) {
              if (data.message == 'Unauthorised or Login Time-out') {
                this.toastr.info(data.message);
                this.router.navigate(["/login"]);

              } else {
                this.toastr.info(data.message);

              }

            }
          },
          err => {
            return console.error(err);
          }
        );
    }
  ngOnDestroy() {

    this.ResponseVerifiedGetAllNormalUserList.next();
    this.ResponseVerifiedGetAllNormalUserList.complete();

    this.ResponseVerifiedGetDevicesNormalUser.next();
    this.ResponseVerifiedGetDevicesNormalUser.complete();

    this.ResponseVerifiedChangePassword.next();
    this.ResponseVerifiedChangePassword.complete();

  }
}
